import useSWR from "swr";
import { api } from "../api";

const fetcher = (url) => api.get(url).then((r) => r.data);

/*
  Words the back room can reword, fetched once and cached by SWR.

  Every call site passes the written-in-code line as a fallback, so the page
  renders correctly on the first paint and still reads properly if the request
  fails. Nothing here ever shows an empty slot.
*/
export function useCopy() {
  const { data } = useSWR("/copy", fetcher, {
    revalidateOnFocus: false,
    dedupingInterval: 60000,
  });
  const map = data?.copy;

  return (key, fallback = "") => {
    const v = map?.[key];
    return typeof v === "string" && v.trim() ? v : fallback;
  };
}

export default useCopy;
